import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { Property } from 'app/modules/projects/projects.types';
import { ProjectType, PropertyType, ProjectStage } from 'app/core/models/account.types';
import { ProjectTenantsService } from 'app/modules/projects/details/tenants/tenants.service';
import unformat from 'accounting-js/lib/unformat.js';

@Component({
  selector: 'project-tenants-add-unit',
  templateUrl: './add-unit.component.html',
  styleUrls: ['./add-unit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectTenantsAddUnitComponent implements OnInit {
  propertyUnitForm: UntypedFormGroup;

  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  property: Property;

  public uploadedFile: any;
  options: [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectTenantsAddUnitComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _projectTenantsService: ProjectTenantsService,
  ) {}

  ngOnInit(): void {
    this.propertyUnitForm = this._formBuilder.group({
      id: [''],
      unit_number: ['', [Validators.required]],
      unit_size: [''],
      floor: [''],
    });

    this.property = this.data.property;
  }

  onFileChanged($event) {
    let file = $event.target.files[0];
    this.uploadedFile = file;
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Send the message
   */
  save(): void {
    this.propertyUnitForm.disable();

    let propertyUnit = this.propertyUnitForm.value;
    propertyUnit.property_id = this.property.id;
    propertyUnit.unit_size = unformat(propertyUnit.unit_size);
    this._projectTenantsService.createPropertyUnit(propertyUnit).subscribe((response) => {
      this.matDialogRef.close();
    });
  }
}
